<template>
    <div>
        <!-- 面包屑导航 -->
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item>系统设置</el-breadcrumb-item>
            <el-breadcrumb-item>机构管理</el-breadcrumb-item>
        </el-breadcrumb>

        <!-- Tabs -->
        <el-tabs v-model="activeName" type="border-card">
            <!-- 清单列表 strat -->
            <el-tab-pane name="first" label="清单列表">
              <el-row :gutter="20">
                <!-- 组织机构 start -->
                <el-col :span="5">
                    <el-tree
                    :data="selectData"
                    @node-click="handleNodeClick"
                    show-checkbox
                    node-key="id"
                    :highlight-current="true"
                    :default-expand-all="true"
                    :expand-on-click-node="false"
                    class="tree1">
                    </el-tree>
                </el-col>
                <!-- 组织机构 end -->
                <!-- 机构列表 start -->
                <el-col :span="19">
                  <el-table :data="mechanismList" border stripe>
                    <el-table-column prop="id" label="ID" width="90px" v-if="SubRule_ShenPiJiGou_Admin"></el-table-column>
                    <el-table-column prop="promotioncode" label="推广码"></el-table-column>
                    <el-table-column prop="name" label="机构名称"></el-table-column>
                    <el-table-column prop="type" label="机构类型"></el-table-column>
                    <el-table-column prop="previous" label="上级机构"></el-table-column>
                    <el-table-column prop="province" label="省"></el-table-column>
                    <el-table-column prop="city" label="市"></el-table-column>
                    <el-table-column prop="area" label="区"></el-table-column>
                    <el-table-column prop="abbreviations" label="缩写"></el-table-column>
                    <el-table-column prop="signingtypes" label="签约属性" v-if="SubRule_ShenPiJiGou_Admin"></el-table-column>
                    <el-table-column prop="yunyingshangjiagetypes" label="运营商价格类型" v-if="SubRule_ShenPiJiGou_Admin"></el-table-column>
                    <el-table-column prop="operation" label="操作" width="200px" v-if="SubRule_ShenPiJiGou_Admin">
                      <template slot-scope="scope">
                        <el-button type="text" size="mini" style="margin-left: 0; margin-right: 5px" @click="clickeditjigou(scope.$index,scope.row)">修改</el-button>
                        <el-button type="text" size="mini" style="margin-left: 0; margin-right: 5px" @click="deleteRow(scope.$index,scope.row)">删除</el-button>
                        <el-button type="text" size="mini" style="margin-left: 0; margin-right: 5px" @click="deleteRows(scope.$index,scope.row)">强制删除</el-button>
                      </template>
                    </el-table-column>
                  </el-table>
                </el-col>
                <!-- 机构列表 end -->
              </el-row>

                <!-- 机构修改弹出框 -->
                <el-dialog title="机构修改" :visible.sync="editdialog" width="40%" :close-on-click-modal="false">
                  <el-form :model="jigoudataedit" ref="addMechanismRef" label-width="120px">
                    <input v-model="jigoudataedit.parentid" type="hidden"></input>
                    <el-form-item label="上级机构" class="addAdminForm">
                        <el-input v-model="jigoudataedit.parentname" placeholder="点击选择机构" @click.native="dialogAdd = true"></el-input>
                    </el-form-item>

                    <el-form-item label="归属区域" class="addAdminFormLong">
                      <el-select v-model="jigoudataedit.province" placeholder="请选择省" class="select1" @change="changeprovince">
                        <el-option
                          v-for="item in optionsprovince" :key="item.value" :label="item.label" :value="item.value">
                        </el-option>
                      </el-select>
                      <el-select v-model="jigoudataedit.city" collapse-tags  class="select1" placeholder="请选择市" @change="changecity">
                        <el-option
                          v-for="item in optionscity" :key="item.value" :label="item.label" :value="item.value">
                        </el-option>
                      </el-select>
                      <el-select v-model="jigoudataedit.area" collapse-tags  class="select1" placeholder="请选择区" style="margin: 0">
                        <el-option
                          v-for="item in optionsarea" :key="item.value" :label="item.label" :value="item.value">
                        </el-option>
                      </el-select>
                    </el-form-item>

                    <el-form-item label="机构名称" class="addAdminForm">
                      <el-input v-model="jigoudataedit.jigouname" placeholder="请输入机构名称"></el-input>
                    </el-form-item>

                    <el-form-item label="机构类型" class="addAdminForm">
                      <el-select v-model="jigoudataedit.jigoutype" placeholder="请选择机构类型" class="select2">
                        <el-option
                          v-for="item in optionsjigoutype" :key="item.value" :label="item.label" :value="item.value">
                        </el-option>
                      </el-select>
                    </el-form-item>

                    <el-form-item label="公司类型" class="addAdminForm">
                        <el-select v-model="jigoudataedit.companytype" placeholder="请选择公司类型" class="select2">
                          <el-option
                            v-for="item in optionscompanytype" :key="item.value" :label="item.label" :value="item.value">
                          </el-option>
                        </el-select>
                    </el-form-item>

                    <el-form-item label="门店类型" class="addAdminForm">
                        <el-select v-model="jigoudataedit.mendiantype" placeholder="请选择门店类型" class="select2">
                          <el-option
                            v-for="item in optionsmendiantype" :key="item.value" :label="item.label" :value="item.value">
                          </el-option>
                        </el-select>
                    </el-form-item>

                    <el-form-item label="签约类型" class="addAdminForm">
                        <el-select v-model="jigoudataedit.signingtype" placeholder="请选择签约类型" class="select2">
                          <el-option
                            v-for="item in optionssigningtype" :key="item.value" :label="item.label" :value="item.value">
                          </el-option>
                        </el-select>
                    </el-form-item>

                    <el-form-item label="运营商价格类型" class="addAdminForm">
                        <el-select v-model="jigoudataedit.yunyingshangjiagetype" placeholder="请选择运营商价格类型" class="select2">
                          <el-option
                            v-for="item in optionsyunyingshangjiagetype" :key="item.value" :label="item.label" :value="item.value">
                          </el-option>
                        </el-select>
                    </el-form-item>

                    <el-form-item>
                        <el-button type="primary" @click="funeditjigou">保存</el-button>
                    </el-form-item>
                  </el-form>
                </el-dialog>
                <!-- 机构修改弹出框 end -->

            </el-tab-pane>
            <!-- 清单列表 end -->

            <!-- 机构添加 start -->
            <el-tab-pane name="second" label="机构添加" v-if="SubRule_ShenPiJiGou_Admin">
                <el-form :model="jigoudataadd" ref="addMechanismRef" label-width="70px">
                  <input v-model="jigoudataadd.parentid" type="hidden"></input>
                  <el-form-item label="上级机构" class="addAdminForm">
                      <el-input v-model="jigoudataadd.parentname" placeholder="点击选择机构" @click.native="dialogAdd = true"></el-input>
                  </el-form-item>

                  <el-form-item label="归属区域" class="addAdminForm">
                      <el-select v-model="jigoudataadd.province" placeholder="请选择省" class="select1" @change="changeprovince">
                        <el-option
                          v-for="item in optionsprovince" :key="item.value" :label="item.label" :value="item.value">
                        </el-option>
                      </el-select>
                      <el-select v-model="jigoudataadd.city" collapse-tags  class="select1" placeholder="请选择市" @change="changecity">
                        <el-option
                          v-for="item in optionscity" :key="item.value" :label="item.label" :value="item.value">
                        </el-option>
                      </el-select>
                      <el-select v-model="jigoudataadd.area" collapse-tags  class="select1" placeholder="请选择区" style="margin: 0">
                        <el-option
                          v-for="item in optionsarea" :key="item.value" :label="item.label" :value="item.value">
                        </el-option>
                      </el-select>
                  </el-form-item>

                  <el-form-item label="机构名称" class="addAdminForm">
                      <el-input v-model="jigoudataadd.jigouname" placeholder="请输入机构名称"></el-input>
                  </el-form-item>

                  <el-form-item label="机构类型" class="addAdminForm">
                      <el-select v-model="jigoudataadd.jigoutype" placeholder="请选择机构类型" class="select2">
                        <el-option
                          v-for="item in optionsjigoutype" :key="item.value" :label="item.label" :value="item.value">
                        </el-option>
                      </el-select>
                  </el-form-item>

                  <el-form-item label="公司类型" class="addAdminForm">
                      <el-select v-model="jigoudataadd.companytype" placeholder="请选择公司类型" class="select2">
                        <el-option
                          v-for="item in optionscompanytype" :key="item.value" :label="item.label" :value="item.value">
                        </el-option>
                      </el-select>
                  </el-form-item>

                  <el-form-item label="门店类型" class="addAdminForm">
                      <el-select v-model="jigoudataadd.mendiantype" placeholder="请选择门店类型" class="select2">
                        <el-option
                          v-for="item in optionsmendiantype" :key="item.value" :label="item.label" :value="item.value">
                        </el-option>
                      </el-select>
                  </el-form-item>

                  <el-form-item>
                      <el-button type="primary" @click="funaddjigou">添加</el-button>
                      <el-button type="info" @click="clickreturn">返回</el-button>
                  </el-form-item>
                </el-form>
            </el-tab-pane>
            <!-- 机构添加 end -->
        </el-tabs>

        <!-- 所属机构弹出提示框 -->
        <el-dialog title="请选所属择机构" :visible.sync="dialogAdd" width="30%" :close-on-click-modal="false">
          <!-- 头部搜索 start -->
          <el-form :inline="true" :model="select" class="demo-form-inline">
              <el-form-item label="选择机构: ">
                  <el-input v-model="select.keywords" placeholder="请输入关键词"></el-input>
              </el-form-item>
              <el-form-item>
                  <el-button type="primary" @click="searchjigou(select.keywords)">搜索</el-button>
              </el-form-item>
          </el-form>
          <!-- 头部搜索 end -->
          <el-tree
            :data="selectDatadialog"
            :highlight-current="true"
            :default-expand-all="true"
            :expand-on-click-node="false"
            node-key="id"
            ref="treedialog"
            class="treedialog"
          ></el-tree>
          <span slot="footer" class="dialog-footer">
              <el-button @click="dialogcancel">取 消</el-button>
              <el-button type="primary" @click="dialogok">确 定</el-button>
          </span>
        </el-dialog>
        <!-- 所属机构弹出提示框 end -->
    </div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Qs from 'qs'
Vue.use(VueAxios, axios)

export default {
  components: {
  },
  name: 'MyOrganizational',
  data () {
    return {
      activeName: 'first',
      dialogDelete: false,
      dialogAdd: false,
      dialogAddBtn: false,
      // 左侧机构数据列表
      selectData: [],
      selectDatadialog: [],
      defaultexpandedkeys: [],
      jigoudataadd: {
        parentid: 0,
        parentname: '',
        province: '',
        city: '',
        area: '',
        jigouname: '',
        jigoutype: '',
        companytype: 1,
        mendiantype: 1
      },
      jigoudataedit: {
        jigouid: 0,
        parentid: 0,
        parentname: '',
        province: 0,
        city: 0,
        area: 0,
        jigouname: '',
        jigoutype: 1,
        companytype: 1,
        mendiantype: 1,
        signingtype: 1,
        yunyingshangjiagetype: 1
      },
      // 机构列表数据
      mechanismList: [],
      // 选择机构
      select: {
        keywords: ''
      },
      editdialog: false,
      optionsprovince: [],
      optionscity: [],
      optionsarea: [],
      optionsjigoutype: [
        { label: '总部', value: 1 },
        { label: '一级管理权限', value: 2 },
        { label: '二级管理权限', value: 3 },
        { label: '三级管理权限', value: 4 },
        { label: '四级管理权限', value: 5 }
      ],
      optionscompanytype: [
        { label: '外部运营商', value: 1 },
        { label: '总部', value: 2 },
        { label: '子公司', value: 3 }
      ],
      optionsmendiantype: [
        { label: '原有门店', value: 1 },
        { label: '合作门店', value: 2 },
        { label: '加盟门店', value: 3 },
        { label: '直营门店', value: 4 },
        { label: '合作专柜', value: 5 }
      ],
      optionssigningtype: [
        { label: '江苏睿世力', value: 1 },
        { label: '北京睿世力', value: 2 },
        { label: '丹阳睿世力', value: 3 }
      ],
      optionsyunyingshangjiagetype: [
        { label: '首次+次次', value: 1 },
        { label: '一直首次', value: 2 }
      ],
      clickparentid: 1,
      SubRule_ShenPiJiGou_Admin: false
    }
  },
  mounted () {
    this.apigetjigoutree()
    this.apigetjigoulist()
    this.apigetregionlist(1, 1)

    var that = this
    Vue.prototype.FunCheckSubRule('SubRule_ShenPiJiGou_Admin', function (response) {
      if (response.data.Code === 200) {
        that.SubRule_ShenPiJiGou_Admin = true
      }
    })
  },
  methods: {
    clickreturn () {
      this.activeName = 'first'
    },
    clickeditjigou (index, row) {
      this.editdialog = true
      this.jigoudataedit.jigouid = row.id
      this.jigoudataedit.parentid = row.parentid
      this.jigoudataedit.parentname = row.previous
      this.apigetregionlist(2, row.provinceid)
      this.apigetregionlist(3, row.cityid)
      this.jigoudataedit.province = row.provinceid.toString()
      this.jigoudataedit.city = row.cityid.toString()
      this.jigoudataedit.area = row.districtid.toString()
      this.jigoudataedit.jigouname = row.name
      this.jigoudataedit.jigoutype = row.jigoutypeid
      this.jigoudataedit.companytype = row.companytype
      this.jigoudataedit.mendiantype = row.mendiantype
      this.jigoudataedit.signingtype = row.signingtype
      this.jigoudataedit.yunyingshangjiagetype = row.yunyingshangjiagetype
    },
    funeditjigou () {
      if (!this.jigoudataedit.province) {
        this.$alert('请选择省', '提示')
        return
      }
      if (!this.jigoudataedit.city) {
        this.$alert('请选择市', '提示')
        return
      }
      if (!this.jigoudataedit.area) {
        this.$alert('请选择区', '提示')
        return
      }
      if (!this.jigoudataedit.jigouname) {
        this.$alert('请输入机构名称', '提示')
        return
      }
      if (!this.jigoudataedit.jigoutype) {
        this.$alert('请选择机构类型', '提示')
        return
      }
      this.apieditjigou()
    },
    // 删除机构确认
    deleteRow (index, row) {
      this.$confirm('是否删除此机构?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.apideletejigou(row.id)
      })
    },
    deleteRows (index, row) {
      this.$confirm('是否强制删除此机构?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.apideletejigouforce(row.id)
      })
    },
    dialogcancel () {
      this.dialogAdd = false
    },
    dialogok () {
      var nodebuf = this.$refs.treedialog.getCurrentNode()
      if (nodebuf) {
        this.jigoudataadd.parentid = nodebuf.id
        this.jigoudataadd.parentname = nodebuf.label
        this.jigoudataedit.parentid = nodebuf.id
        this.jigoudataedit.parentname = nodebuf.label
      } else {
        this.jigoudataadd.parentid = 0
        this.jigoudataadd.parentname = ''
        this.jigoudataedit.parentid = 0
        this.jigoudataedit.parentname = ''
      }
      this.dialogAdd = false
    },
    funaddjigou () {
      if (!this.jigoudataadd.province) {
        this.$alert('请选择省', '提示')
        return
      }
      if (!this.jigoudataadd.city) {
        this.$alert('请选择市', '提示')
        return
      }
      if (!this.jigoudataadd.area) {
        this.$alert('请选择区', '提示')
        return
      }
      if (!this.jigoudataadd.jigouname) {
        this.$alert('请输入机构名称', '提示')
        return
      }
      if (!this.jigoudataadd.jigoutype) {
        this.$alert('请选择机构类型', '提示')
        return
      }
      this.apiaddjigou()
    },
    changeprovince (data) {
      this.apigetregionlist(2, data)
    },
    changecity (data) {
      this.apigetregionlist(3, data)
    },
    handleNodeClick (data) {
      this.clickparentid = data.id
      this.apigetjigoulist()
    },
    searchjigou (keyword) {
      if (keyword.length == 0) {
        this.apigetjigoutree()
      } else {
        this.apigetjigoutreesmall(keyword)
      }
    },
    apigetjigoutree: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        companytype: '0'
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_Getjigoutree, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.selectData = []
            that.selectDatadialog = []
            response.data.List.filter((item1, i1) => {
              var list2 = []
              item1.List.filter((item2, i2) => {
                var list3 = []
                item2.List.filter((item3, i3) => {
                  var list4 = []
                  item3.List.filter((item4, i4) => {
                    var list5 = []
                    item4.List.filter((item5, i5) => {
                      list5.push({ id: item5.Id, label: item5.Jigouname, children: '' })
                    })
                    if (list5.length == 0) list5 = ''
                    list4.push({ id: item4.Id, label: item4.Jigouname, children: list5 })
                  })
                  if (list4.length == 0) list4 = ''
                  list3.push({ id: item3.Id, label: item3.Jigouname, children: list4 })
                })
                if (list3.length == 0) list3 = ''
                list2.push({ id: item2.Id, label: item2.Jigouname, children: list3 })
              })
              if (list2.length == 0) list2 = ''
              that.selectData.push({ id: item1.Id, label: item1.Jigouname, children: list2 })
              that.selectDatadialog.push({ id: item1.Id, label: item1.Jigouname, children: list2 })
            })
            that.defaultexpandedkeys = [1, 285]
          }
		  Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apigetjigoutreesmall: function (keyword) {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        keyword: keyword,
        companytype: '0'
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_Getjigoutreesmall, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code == 200) {
            that.selectDatadialog = []
            response.data.List.filter((item1, i1) => {
              that.selectDatadialog.push({ id: item1.Id, label: item1.Jigouname, children: '' })
            })
          }
		  Vue.prototype.FunCheckApiCode(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apigetjigoulist: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        parentid: that.clickparentid,
        companytype: '0'
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_Getjigoulist, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code == 200) {
            that.mechanismList = []
            response.data.List.filter((item, i) => {
              that.mechanismList.push({
                id: item.Id,
                promotioncode: item.PromotionCode,
                name: item.Jigouname,
                type: item.Jigoutype,
                previous: item.Parentname,
                province: item.Province,
                city: item.City,
                area: item.District,
                parentid: item.Parentid,
                provinceid: item.Provinceid,
                cityid: item.Cityid,
                districtid: item.Districtid,
                jigoutypeid: item.Jigoutypeid,
                companytype: item.Companytype,
                mendiantype: item.Mendiantype,
                signingtype: item.Signingtype,
                signingtypes: item.Signingtypes,
                yunyingshangjiagetype: item.Yunyingshangjiagetype,
                yunyingshangjiagetypes: item.Yunyingshangjiagetypes,
                abbreviations: item.Abbreviations
              })
            })
          }
		  Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apigetregionlist: function (type, parentid) {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        parentid: parentid
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_Getregionlist, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code == 200) {
            if (type == 1) {
              that.optionsprovince = []
              response.data.List.filter((item, i) => {
                that.optionsprovince.push({ value: item.Id, label: item.Name })
              })
            }
            if (type == 2) {
              that.optionscity = []
              response.data.List.filter((item, i) => {
                that.optionscity.push({ value: item.Id, label: item.Name })
              })
            }
            if (type == 3) {
              that.optionsarea = []
              response.data.List.filter((item, i) => {
                that.optionsarea.push({ value: item.Id, label: item.Name })
              })
            }
          }
		  Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiaddjigou: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        parentid: this.jigoudataadd.parentid,
        province: this.jigoudataadd.province,
        city: this.jigoudataadd.city,
        town: this.jigoudataadd.area,
        jigouname: this.jigoudataadd.jigouname,
        jigoutype: this.jigoudataadd.jigoutype,
        companytype: this.jigoudataadd.companytype,
        mendiantype: this.jigoudataadd.mendiantype
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_Addjigou, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCodeWithCallback(response.data, true, function () {
            that.activeName = 'first'
            that.apigetjigoutree()
            that.apigetjigoulist()
            that.apigetregionlist(1, 1)
          })
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apieditjigou: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        jigouid: this.jigoudataedit.jigouid,
        parentid: this.jigoudataedit.parentid,
        province: this.jigoudataedit.province,
        city: this.jigoudataedit.city,
        town: this.jigoudataedit.area,
        jigouname: this.jigoudataedit.jigouname,
        jigoutype: this.jigoudataedit.jigoutype,
        companytype: this.jigoudataedit.companytype,
        mendiantype: this.jigoudataedit.mendiantype,
        signingtype: this.jigoudataedit.signingtype,
        yunyingshangjiagetype: this.jigoudataedit.yunyingshangjiagetype
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_Editjigou, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCodeWithCallback(response.data, true, function () {
            that.editdialog = false
            that.apigetjigoulist()
          })
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apideletejigou: function (jigouid) {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        jigouid: jigouid
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_Deletejigou, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCodeWithCallback(response.data, true, function () {
            that.apigetjigoutree()
            that.apigetjigoulist()
            that.apigetregionlist(1, 1)
          })
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apideletejigouforce: function (jigouid) {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        jigouid: jigouid
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_Deletejigouforce, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCodeWithCallback(response.data, true, function () {
            that.apigetjigoutree()
            that.apigetjigoulist()
            that.apigetregionlist(1, 1)
          })
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    }
  }
}
</script>

<style lang="less" scoped>
.tree1{
  height: 685px;
  overflow-y: scroll;
}
.tree2{
  height: 350px;
  overflow-y: scroll;
}
.tree1::-webkit-scrollbar,
.tree2::-webkit-scrollbar {
    display: none;
}
.select1{
    width: 113px;
    margin-right: 15px;
}
.select2{
    width: 100%;
}
.treedialog {
  height: 350px;
  overflow-y: scroll;
}
.treedialog::-webkit-scrollbar {
  display: none;
}
</style>
